export type CurrencyFormatter = Pick<
  Intl.NumberFormat,
  "format" | "formatToParts"
>;

type FormattableCurrency = {
  code: string;
  format?: { locale: string };
};

const EXPLICIT_CURRENCY_SYMBOLS: Partial<Record<string, string>> = {
  LRD: "L$",
  USD: "US$",
};

const withSymbol = (
  formatter: Intl.NumberFormat,
  symbol: string,
): CurrencyFormatter => {
  const formatToParts: Intl.NumberFormat["formatToParts"] = (value) =>
    formatter
      .formatToParts(value)
      .map((part) =>
        part.type === "currency" ? { ...part, value: symbol } : part,
      );
  return {
    formatToParts,
    format: (value) =>
      formatToParts(value)
        .map((part) => part.value)
        .join(""),
  };
};

export const currencyFormatFor = (
  currency: FormattableCurrency | undefined,
): CurrencyFormatter | undefined => {
  if (!currency?.format) return undefined;

  const formatter = new Intl.NumberFormat(currency.format.locale, {
    style: "currency",
    currency: currency.code,
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  });
  const symbol = EXPLICIT_CURRENCY_SYMBOLS[currency.code];
  return symbol ? withSymbol(formatter, symbol) : formatter;
};
